import { useEffect } from 'react';
import { useSession } from '../../session';
import { usePageviewTracker } from '../common/use-pageview-tracker';
import { RudderstackTracker } from './rudderstack';
import { getUserTraits } from '../common/get-user-traits';
export var RudderstackSessionTracker = function () {
    var session = useSession().data;
    useEffect(function () {
        if (session) {
            RudderstackTracker.getInstance().identify(session.user.id, getUserTraits(session));
        }
    }, [session]);
    usePageviewTracker({
        trackPageView: function () {
            RudderstackTracker.getInstance().trackPageVisit();
        },
    });
    return null;
};
